export default "__VITE_ASSET__OkIBbf9n__"